import Vue from 'vue'
import VueRouter from 'vue-router'
import Layout from '../views/Layout.vue';
import OA from '../views/OA.vue';
import StaffRoutes from './Staff'
import AdminRoutes from './Admin'
import QuotaRoutes from './Quota'
import AppraiseRoutes from './Appraise';
import RankRoutes from './Rank';
import ReportRoutes from './Report';
import oa from './OA'
import _ from 'lodash'
import Service from '@/service'
import i18n from '../i18n/i18n';

Vue.use(VueRouter)

const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}

const routes = [
  {
    path: '/vinda',
    name: 'vinda',
    component: Layout,
    children: [
      {
        path: 'index',
        component: () => import(/* webpackChunkName: "about" */ '../views/Index.vue')
      },
      ...StaffRoutes,
      ...AdminRoutes,
      ...QuotaRoutes,
      ...AppraiseRoutes,
      ...RankRoutes,
      ...ReportRoutes
    ]
  },
  {
    path: '/oa',
    name: 'oa',
    component: OA,
    children: [
      ...oa
    ]
  },
  {
    path: '/index',
    name: 'home',
    component: () => import ('../views/Home')
  },
  {
    path: '/link',
    name: 'link',
    component: ()=> import('../views/Links')
  },
  {
    path: '/todo',
    name: 'todo',
    component: ()=> import('../views/Todo')
  },
  {
    path: '/teamAssessScore',
    name: 'teamAssessScore',
    component: ()=> import('../views/TeamAssessScore')
  },
  {
    path: '/globalTest',
    name: 'GlobalTest',
    component: () => import ('../components/GlobalTest')
  },
  {
    path: '/',
    redirect: '/index'
  },
  {
    path: '/login',
    name: 'login',
    component: () => import( '@/views/Login.vue')
  },
  {
    path: '/componentTest',
    name: 'componentTest',
    component: () => import ('../components/componentTest')
  },
  {
    path: '/pdfPreview',
    name: 'pdfPreview',
    component: () => import ('@/views/Appraise/TargetManage/pdfPreview'), // 目标管理-高管-pdf预览
    meta: {
        title: '目标管理-高管-pdf预览'
    }  
  },
  {
    path: '/scorePdfPreview',
    name: 'scorePdfPreview',
    component: () => import ('@/views/Appraise/ScoreManage/scorePdfPreview'), // 评分管理-高管-pdf预览
    meta: {
        title: '评分管理-高管-pdf预览'
    }  
  },
  {
      path: '/pdf',
      name: 'pdf',
      component: () => import('@/views/Quota/LinkConfig/pdf.vue'),
      meta: { 
          keepAlive: true,
          title: 'PDF预览'
      },
  },
  {
      path: '/image',
      name: 'image',
      component: () => import('@/views/Quota/LinkConfig/image.vue'),
      meta: { 
          keepAlive: true,
          title: '图片预览'
      },
  },
]

/**
 *  更改生产环境 登录地址
 */
function changLoginUrl() {
  if (process.env.NODE_ENV === 'production' && window.location.origin === "https://pm.vinda.com") {
    let loginRouter = routes.find(item => item.name === "login")
    if (loginRouter) {
      loginRouter.path = "/privateLogin"
    }
  }
}
changLoginUrl();

const router = new VueRouter({
  routes
})

router.afterEach((to,from) => {
  setTimeout(() => {
    if(to.meta.title) {
      document.title = i18n.t(to.meta.title)
    } else {
      document.title = i18n.t('systemName')
    }
  }, 100)
})

router.beforeEach((to,from,next) => {
  const Vue$store = router.app.$options.store
  // 判断是否登录 设置当前地址
  const path = to.path;
  if( process.env.NODE_ENV === 'production' && !['error','login'].includes(to.name) ) {
    
    Service.fetch({
      url: 'userIndex',
      params: {
          webUrl: `${location.origin}/web${path}`,
      }
    })
  }
  if(to.name == 'home') {
    Vue$store.dispatch('handleClearRole')
  }
  if (['error','login'].includes(to.name)) { //不限制error页的跳转
    next();
    return void 0;
  }
  let token = Vue.$cookies.get('WEBSESSIONID') || Vue$store.state.token || sessionStorage.getItem("WEBSESSIONID");
  let userInfo = Vue$store.state.userInfo
  let menus = Vue$store.state.menus;
  if(token && !menus.length) {
    Vue$store.dispatch('handleGetUserMenu', []);
  }
  switch(true) {
    case token && _.has(userInfo, 'emplid') && to.name != 'home':
      next()
      break;
    case (token && !(_.has(userInfo, "emplid")) ) || to.name == 'home':
      Vue$store.dispatch('handleSetUserInfoAction').then(flag => {
          if (flag === 'Y') {
            next()
          } else {
            next('/error')
          }
      })
      next()
      break;
    case !token && to.name !='login':
      // next('/login');
      next();
      break;
  }
})

export default router
